import { SideNavTreeInfo } from '../_models/side-nav-tree-info';
import { CirabooksSideNavigationTree } from './side-navigation/cirabooks-sidenav-tree';
import { CommunitySideNavigationTree } from './side-navigation/community-sidenav-tree';
import { ConfigurationsSideNavigationTree } from './side-navigation/configurations-sidenav-tree';
import { CorporateCirabooksSideNavigationTree } from './side-navigation/corporate-cirabooks-sidenav-tree';
import { MyWorkSideNavigationTree } from './side-navigation/mywork-sidenav-tree';
import { MyPortfolioSideNavigationTree } from './side-navigation/portfolio-sidenav-tree';
import { PropertySideNavigationTree } from './side-navigation/property-sidenav-tree';
import { ToolsSideNavigationTree } from './side-navigation/tools-sidenav-tree';

export class SideNavigationTree {
    static bottomMenuItems: SideNavTreeInfo[] = [
        {
            id: 'b1',
            parentId: null,
            name: 'ADVANCE_SEARCH',
            path: '/search',
            params: 'communityId=:communityId',
            icon: 'fas fa-search',
            text: 'Search',
            tooltip: 'Advanced Search',
            openInNewWindow: true,
            items: []
        },
        {
            id: 'b2',
            parentId: null,
            name: 'TOOLS_USER_DIRECTORY',
            path: '/tools/userdirectory',
            icon: 'fas fa-address-book',
            text: 'Directory',
            tooltip: 'User Directory',
            items: []
        },
        {
            id: 'b3',
            parentId: null,
            name: 'CONTACT_US',
            path: '/contact-us',
            icon: 'far fa-life-ring',
            text: 'Contact Us',
            tooltip: 'Contact Us',
            items: []
        },
        {
            id: 'b4',
            parentId: null,
            name: 'MY_CALENDAR',
            path: '/calendar',
            params: 'communityId=:communityId',
            icon: 'fas fa-calendar-alt',
            text: 'Calendar',
            tooltip: 'Calendar',
            openInNewWindow: true,
            items: []
        },
        {
            id: 'b5',
            parentId: null,
            name: 'CIRAMAIL',
            path: '/ciramail',
            icon: 'fas fa-mail-bulk',
            text: 'CiraMail',
            tooltip: 'CiraMail',
            openInNewWindow: true,
            items: []
        },
        {
            id: 'b6',
            parentId: null,
            name: 'TOOLS_LOG_CALL',
            path: '/tools/:communityId/logphonecall',
            params: 'customerId=:customerId',
            icon: '<span class="dx-icon fa-stack"><i class="fas fa-comment-alt fa-stack-1x"></i><i class="fas fa-bars fa-stack-1x fa-inverse"></i></span>',
            text: 'Log Call / Create Case',
            tooltip: 'Log Call / Create Case',
            openInNewWindow: true,
            items: []
        },
        {
            id: 'b7',
            parentId: null,
            name: 'TIME_AND_EXPENSE_MANAGEMENT',
            path: '/gcb/te/time-and-expense-management/home',
            icon: 'fas fa-hand-holding-usd',
            text: 'Time & Expense Management',
            tooltip: 'Time And Expense Management',
            openInNewWindow: true,
            items: []
        },
        {
            id: 'b8',
            parentId: null,
            name: 'CIRAHELP',
            path: '/cirahelp',
            icon: 'fas fa-question',
            text: 'Help',
            tooltip: 'Help',
            openInNewWindow: true,
            items: []
        }
    ];

    static topMenuItems: SideNavTreeInfo[] = [
        {
            id: 't1',
            parentId: null,
            name: 'HOME',
            path: '/home',
            icon: 'fas fa-desktop',
            text: 'My Workspace',
            tooltip: 'Click to clear context',
            items: [],
            isWorkspace: true
        },
        {
            id: 't2',
            parentId: null,
            name: 'MY_PORTFOLIO',
            path: null,
            icon: 'fas fa-id-card-alt',
            text: 'My Portfolio',
            tooltip: 'My Portfolio',
            items: MyPortfolioSideNavigationTree.topItems('t2')
        },
        {
            id: 't3',
            parentId: null,
            name: 'MYWORK',
            path: null,
            icon: 'far fa-list-alt',
            text: 'My Work Queue',
            tooltip: 'My Work Queue',
            items: MyWorkSideNavigationTree.topItems('t3')
        },
        {
            id: 't4',
            parentId: null,
            name: 'CB',
            path: null,
            icon: 'fas fa-dollar-sign',
            text: 'CiraBooks',
            tooltip: 'CiraBooks',
            items: CirabooksSideNavigationTree.topItems('t4')
        },
        {
            id: 't5',
            parentId: null,
            name: 'CCB',
            path: null,
            icon: 'fas fa-dollar-sign',
            text: 'CiraBooks Corporate',
            tooltip: 'CiraBooks Corporate',
            items: CorporateCirabooksSideNavigationTree.topItems('t5')
        },
        {
            id: 't6',
            parentId: null,
            name: 'ADMINISTRATION',
            path: null,
            icon: 'fas fa-users-cog',
            text: 'Administration',
            tooltip: 'Administration',
            items: [
                {
                    id: 't6_1',
                    parentId: 't6',
                    name: 'TOOLS',
                    path: null,
                    icon: '',
                    text: 'Tools',
                    tooltip: 'Tools',
                    items: ToolsSideNavigationTree.topItems('t6_1')
                }
            ]
        },
        {
            id: 't7',
            parentId: null,
            name: 'REPORTS',
            path: '/reports',
            icon: 'fas fa-receipt',
            text: 'Reports',
            tooltip: 'Reports',
            items: []
        },
        {
            id: 't8',
            parentId: null,
            name: 'CONFIGURATIONS',
            path: null,
            icon: 'fas fa-tools',
            text: 'Configurations',
            tooltip: 'Configurations',
            items: ConfigurationsSideNavigationTree.topItems('t8')
        }
    ];

    static communityMenuItems: SideNavTreeInfo[] = [
        {
            id: 'c1',
            parentId: null,
            name: 'HOME',
            path: '/home',
            icon: 'fas fa-desktop',
            text: 'My Workspace',
            tooltip: 'Click to clear context',
            items: []
        },
        {
            id: 'c2',
            parentId: null,
            name: 'COMMUNITY',
            path: null,
            icon: 'fas fa-map-marker-alt',
            text: 'Community',
            tooltip: 'Community',
            items: CommunitySideNavigationTree.communityRootItems('c2')
        },
        {
            id: 'c3',
            parentId: null,
            name: 'ENTITY_ADMINISTRATION',
            path: null,
            icon: 'fas fa-users-cog',
            text: 'Entity Administration',
            tooltip: 'Entity Administration',
            items: [
                {
                    id: 'c3_1',
                    parentId: 'c3',
                    name: 'TOOLS',
                    path: null,
                    icon: '',
                    text: 'Tools',
                    tooltip: 'Tools',
                    items: ToolsSideNavigationTree.communityItems('c3_1')
                }
            ]
        },
        {
            id: 'c4',
            parentId: null,
            name: 'CB',
            path: null,
            icon: 'fas fa-dollar-sign',
            text: 'CiraBooks',
            tooltip: 'CiraBooks',
            items: CirabooksSideNavigationTree.communityItems('c4')
        },
        {
            id: 'c5',
            parentId: null,
            name: 'MYWORK',
            path: null,
            icon: 'far fa-list-alt',
            text: 'My Work Queue',
            tooltip: 'My Work Queue',
            items: MyWorkSideNavigationTree.communityItems('c5')
        }
    ];

    static propertyMenuItems: SideNavTreeInfo[] = [
        {
            id: 'p1',
            parentId: null,
            name: 'HOME',
            path: '/home',
            icon: 'fas fa-desktop',
            text: 'My Workspace',
            tooltip: 'Click to clear context',
            items: []
        },
        {
            id: 'p2',
            parentId: null,
            name: 'COMMUNITY',
            path: null,
            icon: 'fas fa-map-marker-alt',
            text: 'Community',
            tooltip: 'Community',
            items: CommunitySideNavigationTree.propertyCommunityRootItems('p2')
        },
        {
            id: 'p3',
            parentId: null,
            name: 'PROPERTY',
            path: null,
            icon: 'fas fa-house-user',
            text: 'Property',
            tooltip: 'Property',
            items: PropertySideNavigationTree.propertyRootItems('p3')
        }
    ];

    static topTreeItems: SideNavTreeInfo[] = [].concat(SideNavigationTree.topMenuItems);
    static propertyTreeItems: SideNavTreeInfo[] = [].concat(SideNavigationTree.propertyMenuItems);
    static communityTreeItems: SideNavTreeInfo[] = [].concat(SideNavigationTree.communityMenuItems);

    static masterTreeItems: SideNavTreeInfo[] = []
        .concat(SideNavigationTree.topTreeItems)
        .concat(SideNavigationTree.communityTreeItems)
        .concat(SideNavigationTree.propertyTreeItems);

    static hiddenPropertyItems: SideNavTreeInfo[] = [].concat(PropertySideNavigationTree.hiddenPropertyItems('p100'));

    static flattenSideNavTreeItems(treeItems: SideNavTreeInfo[], flatItems = []): SideNavTreeInfo[] {
        treeItems.forEach((menu) => {
            flatItems.push({ ...menu, items: [] });
            SideNavigationTree.flattenSideNavTreeItems(menu.items, flatItems);
        });
        return flatItems;
    }
}
